require('../../core/require');
require('./page.css');
import { CodesCompetence } from '../../shared/enums/codes-competence.enum';
import { StoreKeys } from '../../shared/enums/store-keys.enum';
import { StoreManager } from '../../shared/services/store-manager';

const COMPETENCE_NOT_ALLOWED = [CodesCompetence.CSCE];

let compNotAllowed = true;
let sirenCompetences;

/* *************************************************************************************************** */
/* *************************** Souscription et création d'évènement ********************************** */
/* *************************************************************************************************** */
StoreManager.subscribe(StoreKeys.SELECTED_SIREN, _displayOnSelectedSirenChanged.bind(this));

/**
 * Check donnée type de competence en changement de siren
 * @returns {Promise}
 */
function subscribeSirenCompetences() {
  return new Promise((resolve) => {
    StoreManager.subscribe(StoreKeys.SIREN_COMPETENCES, (newSirenCompetences) => {
      sirenCompetences = newSirenCompetences;
      resolve(sirenCompetences);
    });
  });
}

/* *************************************************************************************************** */
/* ***************************************** Fonctions *********************************************** */
/* *************************************************************************************************** */
/**
 * Met à jour l'URL et cache, affiche ou recharge l'iframe si nécessaire
 * Si une collectivité a été sélectionnée : regénère l'URL et affiche le portail dev
 * Sinon, affiche le bloc "Veuillez sélectionner une collectivité"
 * Méthode surchargée pour éviter que le portail dev s'affiche par défaut
 * @private
 * @param siren {string} Le siren sélectionné
 */
async function _displayOnSelectedSirenChanged(siren) {
  await subscribeSirenCompetences();
  if (sirenCompetences === null) {
    sirenCompetences = await StoreManager.getSirenCompetences();
  }

  if (sirenCompetences.length > 1) {
    compNotAllowed = sirenCompetences.every((collectivite) =>
      COMPETENCE_NOT_ALLOWED.includes(collectivite.competences[0].type),
    );
  } else {
    compNotAllowed = COMPETENCE_NOT_ALLOWED.includes(sirenCompetences.competences[0].type);
  }

  if (compNotAllowed) {
    afficherFonctionnaliteInaccessible();
  } else {
    afficherPageCoupures();
  }
}

/* *************************************************************************************************** */
/* ************************************** Affichage pages ******************************************** */
/* *************************************************************************************************** */
/**
 * Cache toutes les pages et affiche seulement celle demandée
 * @param ids {Array} Liste d'ids a afficher (optionnel)
 */
function afficherPage(ids = []) {
  let array = ['#bloc-inaccessible', '#bloc-coupures'];

  document.querySelectorAll(array.toString()).forEach((bloc) => (bloc.hidden = true));
  if (ids.length > 0) {
    ids.forEach((id) => {
      let blocAfficher = document.getElementById(id);
      if (blocAfficher) blocAfficher.hidden = false;
    });
  }
}

function afficherFonctionnaliteInaccessible() {
  afficherPage(['bloc-inaccessible']);
  document.getElementById('bloc-inaccessible').hidden = false;
}

function afficherPageCoupures() {
  afficherPage(['bloc-coupures']);
  document.getElementById('bloc-coupures').hidden = false;
}
